import { getDefaultMargin, getDefaultMarginOverlay, getDefaultWidthOverlay } from '../utils'

export const VideoDesignSettings = {
  // dimension
  'video-design-width': {
    phone: ['100%'],
    'phone-landscape': ['50%'],
    tablet: ['100%'],
    'tablet-landscape': ['50%'],
    desktop: ['50%'],
    tv: ['50%'],
    overflowSetting: getDefaultWidthOverlay,
  },

  // spacing
  'video-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'video-design-padding': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },

  // alignment
  'video-design-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },

  // aspect ratio
  'video-design-ratio': {
    phone: '16:9',
    'phone-landscape': '16:9',
    tablet: '16:9',
    'tablet-landscape': '16:9',
    desktop: '16:9',
    tv: '16:9',
  },
}
